import script from "./guestLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./guestLayout.vue?vue&type=script&setup=true&lang=js"

import "./guestLayout.vue?vue&type=style&index=0&id=23060aaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23060aaa"]])

export default __exports__